import RouterStore from '@/store/RouterStore';
import config from '../misc/Configuracao';
import { MotivosImpedimento } from '../modelo/MotivosImpedimento';
import { IParametroSistema } from '../modelo/ParametroSistema';
import { ITipoPeticaoPendente } from '../modelo/TipoPeticaoPendente';
import fetch from './AxiosAdapter';
import { apresentarApiErroPadrao } from '@/utils/ApiErroPadraoUtils';

export class ParametroSistemaApi {

    static parametrosMock = [];

    async verificarResultado(result) {
        if (result.status >= 400) {
            if (apresentarApiErroPadrao(result?.data)) {
                throw result.data;
            }
            const erro = result.data;
            throw new Error(erro ? erro.mensagem : null);
        }
    }

    //MANTEM
    async salvar(parametro) {
        let result;
        const id = parametro.id ? parametro.id : '';
        if (parametro.dataUltimaAlteracao) {
            parametro.dataUltimaAlteracao = undefined;
        }
        try {
            let url = config.urlBaseGE + 'api/parametros/' + id;
            if (RouterStore.isPrd) {
                url = config.urlBaseMinuta + 'parametros/' + id;
            }

            result = await fetch(url,
                {
                    method: parametro.id ? 'PUT' : 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: parametro
                });
            await this.verificarResultado(result);
        } catch (erro) {
            if (apresentarApiErroPadrao(erro)) {
                throw erro;
            }
            const message = "Não foi possível salvar o parâmetro. " + erro + " " + (result ? result.statusText : "");
            console.error(message);
            throw new Error(message);
        }

        return result;
    }

    //MANTEM
    async excluir(parametro) {
        let result;
        try {
            let url = config.urlBaseGE + 'api/parametros/' + parametro.id;
            if (RouterStore.isPrd) {
                url = config.urlBaseMinuta + 'parametros/' + parametro.id;
            }
            result = await fetch(url,
                { method: 'DELETE' });
            await this.verificarResultado(result);
        } catch (erro) {
            if (apresentarApiErroPadrao(erro)) {
                throw erro;
            }
            const message = "Não foi possível excluir o parâmetro. " + erro + " " + (result ? result.statusText : "");
            console.error(message);
            throw new Error(message);
        }

        return result;

    }

    async todosParametros(): Promise<IParametroSistema[]> {
        let result;
        try {
            result = await fetch(config.urlParametrosMinuta);
            if (result.status !== 200) {
                console.error('Erro ao carregar parâmetros - Status:', result.status);
                throw new Error('Não foi possível recuperar os parâmetros. Tente novamente.');
            }
            return result.data;
        } catch (error) {
            console.error('Erro na chamada da API:', error);
            if (apresentarApiErroPadrao(error)) {
                throw error;
            }
            throw new Error('Ocorreu um erro em sua solicitação. Por favor, tente novamente. Caso persista comunique ao administrador do sistema.');
        }
    }

    async recuperaTiposPeticoesPendentes(): Promise<ITipoPeticaoPendente[]> {
        let tiposDocs;
        try {
            tiposDocs = await fetch(config.urlTiposDocumentoProcesso);
        } catch (error) {
            console.error(error);
            if (apresentarApiErroPadrao(error)) {
                throw error;
            }
            throw new Error('Ocorreu um erro em sua solicitação. Por favor, tente novamente. Caso persista comunique ao administrador do sistema.');
        }
        if (tiposDocs.status !== 200) {
            throw new Error('Não foi possível recuperar os parâmetros. Tente novamente.');
        }
        return await tiposDocs.data;
    }

    async recuperaTiposImpedimentos(): Promise<MotivosImpedimento[]> {
        const result = await fetch<MotivosImpedimento[]>(config.urlMotivosImpedimento);
        return result.data;
    }


    async recuperarIntegracaoLegadoHabilitada() {
        let result;

        try {
            result = await fetch(config.urlParametrosMinuta + '?nome=IntegracaoLegadoHabilitada');
            const flagValor = (result.data)[0].valor;
            return flagValor === 'S';
        } catch (error) {
            console.error(result);
            if (apresentarApiErroPadrao(error)) {
                throw error;
            }
            throw new Error('Ocorreu um erro em sua solicitação. Por favor, tente novamente. Caso persista comunique ao administrador do sistema.');
        }
    }

    async recuperarParametrosCargos() {
        let siglaPresidente;
        let siglaVicePresidente;
        let siglaCorregedor;

        const cargos = new Map();

        try {
            siglaPresidente = await fetch(config.urlParametrosMinuta + '?nome=Presidente');
            siglaVicePresidente = await fetch(config.urlParametrosMinuta + '?nome=VicePresidente');
            siglaCorregedor = await fetch(config.urlParametrosMinuta + '?nome=CorregedorGeral');
            cargos.set(0, siglaPresidente.data[0].valor);
            cargos.set(1, siglaVicePresidente.data[0].valor);
            cargos.set(2, siglaCorregedor.data[0].valor);
            return cargos;
        } catch (error) {
            console.error(cargos);
            if (apresentarApiErroPadrao(error)) {
                throw error;
            }
            throw new Error('Ocorreu um erro em sua solicitação. Por favor, tente novamente. Caso persista comunique ao administrador do sistema.');
        }
    }

    async recuperarVersaoPJe(): Promise<string> {
        let result;
        try {
            result = await fetch(config.urlVersaoPje);
        } catch (error) {
            if (apresentarApiErroPadrao(error)) {
                throw error;
            }
            throw new Error('Ocorreu um erro em sua solicitação. Por favor, tente novamente. Caso persista comunique ao administrador do sistema.');
        }
        if (result.status !== 200) {
            throw new Error('Não foi possível recuperar a versão do PJe. Comunique o administrador do sistema.');
        }
        const raw = result.data?.[0];
        if (typeof raw !== 'string' || raw.indexOf('{') === -1) {
            return '';
        }
        const info = JSON.parse(raw.substring(raw.indexOf('{')));
        return info.versao || '';
    }
}

export default new ParametroSistemaApi();
